import React from 'react'
import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function Footer() {
    const {t} = useTranslation();
    return (
        <Paper sx={{
            position: 'fixed',
            bottom: 0,
            width: '100%',
            zIndex: 12
        }} component="footer" square variant="outlined">
            <Box
                sx={{
                    flexGrow: 1,
                    justifyContent: "center",
                    display: "flex",
                    p: 0.5,
                }}
            >
                <Typography variant="caption" color="initial">
                © {new Date().getFullYear()} {t('main.footer')}
                </Typography>
            </Box>
        </Paper>
    )
}

export default Footer